export default "__VITE_ASSET__BR14rjK3__"